import React from "react";

type Props = { className?: string; style?: React.CSSProperties };

export const WealthEllipseGlow: React.FC<Props> = ({ className = "", style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 1118 663"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse cx="559" cy="331.5" rx="559" ry="331.5" fill="url(#wm-ellipse-glow-gradient)" fillOpacity="0.7" />
    <defs>
      <radialGradient
        id="wm-ellipse-glow-gradient"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-327.761 331.5 -559 -194.37 559 331.5)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D441D6" />
        <stop offset="0.427885" stopColor="#E4A96B" />
        <stop offset="0.657599" stopColor="#FEB7FF" stopOpacity="0.42029" />
        <stop offset="0.831731" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);
